<!-- overview aprender= panel -->

<ng-container>
  <main class="max-w-7xl  mx-auto pt-[80px] md:pt-[90px]">
    <div class="md:mx-0 mx-0 md:py-6 space-y-6  pt-[40px] md:pt-0" style="border-bottom: 1px solid #ececec;">
      <div class="flex flex-col lg:flex-row gap-6 min-h-[18rem] md:rounded-xl bg-white shadow-sm overflow-hidden p-6">

        <div class="flex flex-col justify-center flex-1 lg:max-w-[60%] gap-1  mt-2 md:mt-0">
          <div class="mb-3 mt-2 md:mt-0">
            <span
              class="inline-flex items-center px-3 py-1 rounded-full bg-secondary-100 text-secondary-500 font-semibold uppercase tracking-wider text-[0.7rem]">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="w-3.5 h-3.5">
                <path
                  d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z">
                </path>
                <path d="M20 3v4"></path>
                <path d="M22 5h-4"></path>
                <path d="M4 17v2"></path>
                <path d="M5 18H3"></path>
              </svg>
              <span class="mr-1 ml-2">E-learning </span>
              <span class="
ext-gray-900 overflow-hidden text-ellipsis line-clamp-1">{{ company?.name || company?.experience?.name }}</span>
            </span>
          </div>

          <h2 class="font-bold text-gray-800 tracking-tight text-2xl md:text-3xl mb-1">{{'words.hi' | translate}} {{ shortName }},
          </h2>
          <p class="text-xl md:text-2xl font-medium text-foreground/50 mb-2">{{'words.your-next-step-awaits' | translate}} </p>
          <div class="md:mb-6 max-w-[90%]">
            <p #announceText class="text-base font-normal text-foreground/60"
              [class.line-clamp-3]="!announceExpanded">
              {{company.experience.announceMessage}}
            </p>
            <button *ngIf="announceOverflowing" type="button" (click)="toggleAnnounce()"
              class="mt-1 text-sm font-semibold text-primary-500 hover:underline">
              {{ (announceExpanded ? 'words.see-less' : 'words.see-more') | translate }}
            </button>
          </div>

          <div class="hidden md:flex flex-col md:flex-row gap-3 md:items-center">
            <!-- Botón "Continuar aprendiendo" con efecto hover mejorado -->
            <button [routerLink]="['/learn', company?.slug, 'contents']"
              class="group relative flex items-center w-fit rounded-full bg-gray-900 cursor-pointer transition-all duration-300 overflow-hidden hover:shadow-lg hover:shadow-gray-900/20 hover:scale-[1.02] active:scale-[0.98]">

              <!-- Efecto de brillo sutil al hacer hover -->
              <span
                class="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700"></span>

              <span
                class="relative pl-6 pr-3 py-2.5 text-sm font-semibold text-white transition-all duration-300 group-hover:pr-4">
                {{'words.continue-learning' | translate}}
              </span>

              <span
                class="relative w-7 h-7 rounded-full bg-white flex items-center justify-center mr-1.5 shrink-0 transition-all duration-300 group-hover:bg-primary group-hover:scale-110">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="w-3.5 h-3.5 text-gray-900 transition-all duration-300 group-hover:text-primary-500 ">
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
                </svg>
              </span>
            </button>

            <!-- Botón "Explorar catálogo" -->
            <span [routerLink]="['/learn', company?.slug, 'catalogue', 'all']"
              class="group relative text-sm font-medium text-foreground cursor-pointer transition-all duration-300 hover:text-primary py-2">
              {{'words.explore-catalog' | translate}}
              <!-- Línea animada debajo del texto -->
              <span
                class="hidden absolute bottom-0 left-0 w-0 h-0.5 bg-primary-400 transition-all duration-300 group-hover:w-full"></span>
              <!-- Flecha sutil que aparece al hacer hover -->
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="inline-block text-primary-500 ml-1 w-3 h-3 opacity-0 -translate-x-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0">
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </span>
          </div>
        </div>

        <!-- Slider -->
        <div
          class="slider-imagenes-portada banner2-container overflow-hidden rounded-xl min-h-[200px] md:min-h-[300px] flex-1 lg:max-w-[40%] relative"
          *ngIf="bannerInfo && bannerInfo.length > 0">

          <ng-container *ngFor="let content of bannerInfo; let i = index">
            <!-- Slide -->
            <div class="mySlides fade" style="display: none;">
              <!-- Journey type - use href -->
              <ng-container *ngIf="content?.contentType === 'journey' && content?.actionUrl != null">
                <a [href]="baseUrl + content?.actionUrl" [target]="content?.actionType"
                  class="block w-full h-full cursor-pointer">
                  <img [src]="content?.imageUrl" [alt]="content?.title"
                    class="absolute inset-0 w-full h-full object-cover transition-opacity duration-500 hover:opacity-90">
                </a>
              </ng-container>
              <!-- Course instance or external content - use routerLink -->
              <ng-container
                *ngIf="(content?.contentType === 'course_instance' || content?.contentType === 'external_content') && content?.actionUrl != null">
                <a [routerLink]="getActionUrl(content?.actionUrl)" class="block w-full h-full cursor-pointer">
                  <img [src]="content?.imageUrl" [alt]="content?.title"
                    class="absolute inset-0 w-full h-full object-cover transition-opacity duration-500 hover:opacity-90">
                </a>
              </ng-container>
              <!-- Other type - use href -->
              <ng-container *ngIf="content?.contentType === 'other' && content?.actionUrl != null">
                <a [href]="content?.actionUrl" [target]="content?.actionType"
                  class="block w-full h-full cursor-pointer">
                  <img [src]="content?.imageUrl" [alt]="content?.title"
                    class="absolute inset-0 w-full h-full object-cover transition-opacity duration-500 hover:opacity-90">
                </a>
              </ng-container>
              <!-- No action URL - just image -->
              <ng-container *ngIf="!content?.actionUrl">
                <img [src]="content?.imageUrl" [alt]="content?.title"
                  class="absolute inset-0 w-full h-full object-cover transition-opacity duration-500">
              </ng-container>
            </div>
          </ng-container>

          <!-- All Info overlays - positioned absolutely at bottom -->
          <ng-container *ngFor="let content of bannerInfo; let i = index">
            <div
              class="descripcion-portada absolute bottom-0 inset-x-0 p-5 bg-gradient-to-t from-black/90 via-black/60 to-transparent"
              style="display: none;">
              <header>
                <span class="block text-[10px] font-bold uppercase tracking-widest text-white/60">
                  <ng-container *ngIf="content?.contentType === 'journey'">{{ 'studio.journey' | translate
                    }}</ng-container>
                  <ng-container *ngIf="content?.contentType !== 'journey'">{{content?.providerName}}</ng-container>
                </span>
                <h3 class="block mt-1 text-base font-semibold leading-tight text-white/90 line-clamp-2">{{content?.title
                  | translate}}</h3>
                <span class="block mt-1.5 text-xs text-white/70" *ngIf="content?.duration">
                  {{convertSecondsToHoursMinutes(content?.duration)}}
                </span>

                <ng-container *ngIf="content?.contentType === 'journey' && content?.actionUrl != null">
                  <a class="mt-1.5 mb-2 md:mb-0 text-[10px] py-1.5 md:py-0 text-white/70" palette="secondary" [href]="baseUrl + content?.actionUrl"
                    [target]="content?.actionType">
                    <span class="text-[10px] md:text-sm">{{content?.buttonLabel | translate}}</span>
                    <i class="fas fa-angle-double-right ml-2"></i>
                  </a>
                </ng-container>
                <ng-container
                  *ngIf="(content?.contentType === 'course_instance' || content?.contentType === 'external_content') && content?.actionUrl != null">
                  <a class="mt-1.5 mb-2 md:mb-0 text-[10px] py-1.5 md:py-0 text-white/70" palette="secondary"
                    [routerLink]="getActionUrl(content?.actionUrl)">
                    <span class="text-[10px] md:text-sm">{{content?.buttonLabel | translate}}</span>
                    <i *ngIf="content.actionType === '_self'" class="fas fa-angle-double-right ml-2"></i>
                    <i *ngIf="content.actionType !== '_self'" class="fa-solid fa-up-right-from-square ml-2"></i>
                  </a>
                </ng-container>
                <ng-container *ngIf="content?.contentType === 'other' && content?.actionUrl != null">
                  <a class="mt-1.5 mb-2 md:mb-0 text-[10px] py-1.5 md:py-0 text-white/70" palette="secondary" [href]="content?.actionUrl"
                    [target]="content?.actionType">
                    <span class="text-[10px] md:text-sm">{{content?.buttonLabel | translate}}</span>
                    <i *ngIf="content.actionType === '_self'" class="fas fa-angle-double-right ml-2"></i>
                    <i *ngIf="content.actionType !== '_self'" class="fa-solid fa-up-right-from-square ml-2"></i>
                  </a>
                </ng-container>
              </header>
            </div>
          </ng-container>

          <!-- Bar indicators — overlaid at the very bottom of the slider -->
          <div class="banner2-bars" *ngIf="bannerInfo?.length > 1">
            <button *ngFor="let c of bannerInfo; let i = index" class="slide-bar" (click)="currentSlide(i + 1)"
              [attr.aria-label]="'Slide ' + (i + 1)">
            </button>
          </div>

          <!-- Prev Button -->
          <button *ngIf="bannerInfo?.length > 1" type="button" id="prev"
            class="group absolute left-4 z-10 w-10 h-10 rounded-full bg-white/60 backdrop-blur-sm flex items-center justify-center  hover:scale-110 transition-all duration-300 shadow-lg border border-gray-200/50">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="w-4 h-4 text-gray-600 group-hover:text-gray-700 transition-colors">
              <path d="m15 18-6-6 6-6"></path>
            </svg>
          </button>

          <!-- Next Button -->
          <button *ngIf="bannerInfo?.length > 1" type="button" id="next"
            class="group absolute right-4 z-10 w-10 h-10 rounded-full bg-white/60 backdrop-blur-sm flex items-center justify-center  hover:scale-110 transition-all duration-300 shadow-lg border border-gray-200/50">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="w-4 h-4 text-gray-600 group-hover:text-gray-700 transition-colors">
              <path d="m9 18 6-6-6-6"></path>
            </svg>
          </button>
        </div>

        <!-- Botones móvil: controlados por SCSS (.mobile-action-buttons), no aparecen en desktop -->
        <div class="mobile-action-buttons flex-row gap-2 items-center px-1 pt-1">
          <!-- Continuar aprendiendo (pequeño) -->
          <button [routerLink]="['/learn', company?.slug, 'contents']"
            class="flex items-center gap-1.5 px-3 py-2 rounded-full bg-gray-900 text-white text-xs font-semibold">
            {{'words.continue-learning' | translate}}
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/><polygon points="10 8 16 12 10 16 10 8"/>
            </svg>
          </button>
          <!-- Explorar catálogo (gris) -->
          <span [routerLink]="['/learn', company?.slug, 'catalogue', 'all']"
            class="flex items-center gap-1 px-3 py-2 rounded-full bg-gray-100 text-gray-700 text-xs font-semibold cursor-pointer">
            {{'words.explore-catalog' | translate}}
          </span>
        </div>
      </div>

      <div class="mx-4 md:mx-auto max-w-7xl grid grid-cols-1 md:grid-cols-2 gap-4"
           [ngClass]="academicProfileEnabled ? 'lg:grid-cols-4' : 'lg:grid-cols-3'">

        <!-- Card 1: Horas de aprendizaje -->
        <div
          class="relative bg-white rounded-lg border border-border shadow-sm px-4 py-3 flex items-center gap-3 hover:shadow-md transition-all group">
          <div
            class="shrink-0 w-10 h-10 rounded-full flex items-center justify-center bg-secondary-100 group-hover:bg-secondary/20 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="text-secondary">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
          </div>

          <div class="flex flex-col min-w-0 flex-1">
            <p class="text-[10px] font-bold uppercase tracking-widest text-foreground/60">{{'overview.stats.time.hours'
              | translate}}</p>
            <!-- skeleton while waiting -->
            <div *ngIf="!userCourseAndTimeStats" class="skeleton-text h-6 w-20 rounded mt-1"></div>
            <div *ngIf="userCourseAndTimeStats" class="flex items-baseline gap-1.5">
              <span class="text-2xl font-bold tracking-tight text-secondary">{{ getDuration()[0] }}</span>
              <span class="text-xs text-muted-foreground truncate">{{ getDuration()[1] | translate }}</span>
            </div>
          </div>

          <!-- Ring: value mirrors the card number -->
          <div class="relative shrink-0 w-12 h-12">
            <svg class="w-full h-full -rotate-90" viewBox="0 0 44 44">
              <defs>
                <linearGradient id="ring-grad-1" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style="stop-color: var(--v2-color-secondary-500)" />
                  <stop offset="80%" style="stop-color: var(--v2-color-secondary-500)" />
                  <stop offset="100%" style="stop-color: var(--v2-color-secondary-400)" />
                </linearGradient>
              </defs>
              <circle cx="22" cy="22" r="18" stroke="#e5e7eb" stroke-width="4" fill="none" />
              <circle cx="22" cy="22" r="18" stroke="url(#ring-grad-1)" stroke-width="4" fill="none"
                stroke-linecap="round" stroke-dasharray="113.1" [attr.stroke-dashoffset]="ringOffset(getDuration()[0], 100)" />
            </svg>
            <div class="absolute inset-0 flex items-center justify-center">
                  <span class="text-[10px] font-bold leading-none text-gray-700">
                {{ userCourseAndTimeStats ? getDuration()[0] : '—' }}
              </span>
            </div>
          </div>
        </div>

        <!-- Card 2: Cursos completados -->
        <div
          class="relative bg-white rounded-lg border border-border shadow-sm px-4 py-3 flex items-center gap-3 hover:shadow-md transition-all group">
          <div
            class="shrink-0 w-10 h-10 rounded-full flex items-center justify-center bg-gray-100 group-hover:bg-gray-100/80">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" class="text-gray-700">
              <path d="M12 7v14" />
              <path
                d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
            </svg>
          </div>
          <div class="flex flex-col min-w-0 flex-1">
            <p class="text-[10px] font-bold uppercase tracking-widest text-foreground/60">{{'overview.stats.courses' |
              translate}}</p>
            <div *ngIf="!userCourseAndTimeStats" class="skeleton-text h-6 w-14 rounded mt-1"></div>
            <div *ngIf="userCourseAndTimeStats" class="flex items-baseline gap-1.5">
              <span class="text-2xl font-bold tracking-tight text-foreground">{{ completedCourses }}</span>
              <span class="text-xs text-muted-foreground truncate">
                {{ (completedCourses > 1 ? 'overview.stats.courses' : 'overview.stats.course') |
                translate }}
              </span>
            </div>
          </div>
          <!-- Ring: value mirrors the card number -->
          <div class="relative shrink-0 w-12 h-12">
            <svg class="w-full h-full -rotate-90" viewBox="0 0 44 44">
              <defs>
                <linearGradient id="ring-grad-2" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style="stop-color: var(--v2-color-secondary-500)" />
                  <stop offset="80%" style="stop-color: var(--v2-color-secondary-500)" />
                  <stop offset="100%" style="stop-color: var(--v2-color-secondary-400)" />
                </linearGradient>
              </defs>
              <circle cx="22" cy="22" r="18" stroke="#e5e7eb" stroke-width="4" fill="none" />
              <circle cx="22" cy="22" r="18" stroke="url(#ring-grad-2)" stroke-width="4" fill="none"
                stroke-linecap="round" stroke-dasharray="113.1" [attr.stroke-dashoffset]="ringOffset(completedCourses, totalCourses)" />
            </svg>
            <div class="absolute inset-0 flex items-center justify-center">
                  <span class="text-[10px] font-bold leading-none text-gray-700">
                {{ userCourseAndTimeStats ? completedCourses : '—' }}
              </span>
            </div>
          </div>
        </div>

        <!-- Card 3: Rutas de aprendizaje -->
        <div
          class="relative bg-white rounded-lg border border-border shadow-sm px-4 py-3 flex items-center gap-3 hover:shadow-md transition-all group">
          <div
            class="shrink-0 w-10 h-10 rounded-full flex items-center justify-center bg-gray-100 group-hover:bg-gray-100/80">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-gray-700">
              <path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z" />
              <path d="M15 5.764v15" />
              <path d="M9 3.236v15" />
            </svg>
          </div>
          <div class="flex flex-col min-w-0 flex-1">
            <p class="text-[10px] font-bold uppercase tracking-widest text-foreground/60">{{'words.journeys' |
              translate}}</p>
            <div *ngIf="!userCourseAndTimeStats" class="skeleton-text h-6 w-10 rounded mt-1"></div>
            <div *ngIf="userCourseAndTimeStats" class="flex items-baseline gap-1.5">
              <span class="text-2xl font-bold tracking-tight text-foreground">{{ completedJourneys }}</span>
              <span class="text-xs text-muted-foreground truncate">{{'words.completed' | translate}}</span>
            </div>
          </div>
          <!-- Ring: value mirrors the card number -->
          <div class="relative shrink-0 w-12 h-12">
            <svg class="w-full h-full -rotate-90" viewBox="0 0 44 44">
              <defs>
                <linearGradient id="ring-grad-3" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style="stop-color: var(--v2-color-secondary-500)" />
                  <stop offset="80%" style="stop-color: var(--v2-color-secondary-500)" />
                  <stop offset="100%" style="stop-color: var(--v2-color-secondary-400)" />
                </linearGradient>
              </defs>
              <circle cx="22" cy="22" r="18" stroke="#e5e7eb" stroke-width="4" fill="none" />
              <circle cx="22" cy="22" r="18" stroke="url(#ring-grad-3)" stroke-width="4" fill="none"
                stroke-linecap="round" stroke-dasharray="113.1" [attr.stroke-dashoffset]="ringOffset(completedJourneys, totalJourneys)" />
            </svg>
            <div class="absolute inset-0 flex items-center justify-center">
                  <span class="text-[10px] font-bold leading-none text-gray-700">
                {{ userCourseAndTimeStats ? completedJourneys : '—' }}
              </span>
            </div>
          </div>
        </div>
<!-- Card 4: Mi perfil académico -->
        <!-- Card 4: Mi perfil académico -->
        <a *ngIf="academicProfileEnabled"
          [routerLink]="['/learn', company?.slug, 'academy', 'details']"
          class="relative bg-white rounded-xl border border-border shadow-sm px-4 py-3 flex items-center gap-3 hover:shadow-md transition-all group no-underline">
          <div class="shrink-0 w-10 h-10 rounded-full flex items-center justify-center bg-gray-100 group-hover:bg-gray-100/80">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-gray-700"><path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"></path><path d="M22 10v6"></path><path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"></path></svg>
          </div>
          <div class="flex flex-col min-w-0 flex-1">
            <p class="text-[10px] font-bold uppercase tracking-widest text-foreground/60">{{ "words.my-academic-profile" | translate }}</p>
            <span class="text-sm font-semibold tracking-tight text-gray-700 mt-1">{{ "words.go-to-my-profile" | translate }}</span>
          </div>
          <div class="shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-gray-700 group-hover:translate-x-0.5 transition-transform">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>
          </div>
        </a> 

      </div>
    </div>
  </main>

  <!-- BANNER IMG-->
  <ng-container *ngIf="false">
    <!--PLANTILLA SKELETON CAROUSEL BANNER IMG-->
    <div class=" my-10 mx-auto w-full max-w-[90%] lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%]">
      <div *ngIf="isLoadingSkeleton; else sliderContent" class="slider-skeleton pointer-events-none">
        <div class="skeleton-slide rounded-[14px]"></div>
      </div>
    </div>

    <!--CAROUSEL BANNER IMG-->
    <div class=" my-10 mx-auto w-full max-w-[90%] lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%]">
      <ng-template #sliderContent>
        <div class="slider-imagenes-portada">
          <ng-container *ngFor="let content of bannerInfo">
            <div class="mySlides fade rounded-[14px]">
              <img [src]="content?.imageUrl" class="imagen-portada rounded-[14px]">
              <div class="container-degradate rounded-[14px]"></div>
            </div>

            <!-- Descripciones -->
            <div class="descripcion-portada gap-2 w-full lg:w-3/5">
              <p class="text-white  text-opacity-80 uppercase text-base">{{content?.providerName}}</p>
              <h2 class="text-lg md:text-2xl font-semibold text-white  line-clam-2">{{content?.title | translate}}</h2>
              <p
                class="text-start line-clamp-2 description-3 md:4/5 lg:w-4/5 w-4/5 text-sm md:text-base font-normal text-white text-opacity-80">
                {{content?.description | translate}}</p>
              <div class="flex items-center mt-2" *ngIf="content?.duration">
                <i class="fa fa-clock text-gray-300 fa-sm text-lg"></i> <span
                  class="ml-2">{{convertSecondsToHoursMinutes(content?.duration)}}</span>
              </div>
              <ng-container *ngIf="content?.contentType === 'journey' && content?.actionUrl != null">
                <a class="mt-1.5 text-xs text-white/70" palette="secondary" [href]="baseUrl + content?.actionUrl"
                  [target]="content?.actionType">
                  <span class="text-xs md:text-sm mx-2 ">{{content?.buttonLabel | translate}}</span>
                  <i class="fas fa-angle-double-right ml-2"></i>
                </a>
              </ng-container>
              <ng-container
                *ngIf="content?.contentType === 'course_instace' || content?.contentType === 'external_content' && content?.actionUrl != null">
                <a class="uppercase hover:text-white transition msc-button--primary  font-semibold  w-4/6 flex gap-2 items-center justify-start text-white p-2 custom-full-width banner-gradient-btn"
                  palette="secondary" [routerLink]="getActionUrl(content?.actionUrl)">
                  <span class="text-xs md:text-sm mx-2 ">{{content?.buttonLabel | translate}}</span>
                  <i *ngIf="content.actionType === '_self'" class="fas fa-angle-double-right ml-2"></i>
                  <i *ngIf="content.actionType !== '_self'" class="fa-solid fa-up-right-from-square ml-2"></i>
                </a>
              </ng-container>
              <ng-container *ngIf="content?.contentType === 'other' && content?.actionUrl != null">
                <a class="mt-1.5 text-xs text-white/70" palette="secondary" [href]="content?.actionUrl"
                  [target]="content?.actionType">
                  <span class="text-xs md:text-sm mx-2 ">{{content?.buttonLabel | translate}}</span>
                  <i *ngIf="content.actionType === '_self'" class="fas fa-angle-double-right ml-2"></i>
                  <i *ngIf="content.actionType !== '_self'" class="fa-solid fa-up-right-from-square ml-2"></i>
                </a>
              </ng-container>
            </div>
          </ng-container>


          <!-- Botones de navegación -->
          <button type="button" class="boton" id="prev">
            <i class="text-md fa-solid fa-chevron-left w-5 h-5 text-foreground/50 flex justify-center items-center"></i>
          </button>
          <button type="button" class="boton" id="next">
            <i class="text-md fa-solid fa-chevron-right w-5 h-5 text-gray-400 flex justify-center items-center"></i>
          </button>

          <!-- Bullets -->
          <div class="bullet-container">
            <span *ngFor="let content of bannerInfo; let i = index" class="dot" (click)="currentSlide(i + 1)"></span>
          </div>
        </div>
      </ng-template>
    </div>
  </ng-container>

  <!-- GRIKY SKILLS WIDGET (viejo — comentado por si se necesita) -->
  <!--
  <div *ngIf="grikySkillsEnabled" class="mx-4 md:mx-auto max-w-7xl mt-2 mb-4">
    <msc-widget-griky-skills
      [companyId]="company.id"
      [companySlug]="company.slug">
    </msc-widget-griky-skills>
  </div>
  -->

  <!-- MIS COMPETENCIAS (mismo componente de la academia, vista LISTA) -->
  <div *ngIf="grikySkillsEnabled" class="mx-4 md:mx-auto max-w-7xl mt-2 mb-4">
    <app-skills-competencies [view]="'list'" [autoLoad]="true" [companySlug]="company?.slug"></app-skills-competencies>
  </div>

  <!--CAROUSEL CONTENIDOS-->
  <!--RECIENTES -->
  <section *ngIf="contents && contents.length > 0">
    <app-owl-carousel [title]="'words.recently-view' | translate" [contents]="contents" [origin]="'subscribed'"
      [zIndex]="40">
    </app-owl-carousel>
  </section>

  <!--RECOMENDADOS -->
  <section class="md:pt-0 pt-10" *ngIf="recommendedCompanyContentsByLearner && recommendedCompanyContentsByLearner.length > 0">
    <app-owl-carousel [title]="'words.recommended' | translate" [subtitle]="'words.recommended.subtitle' | translate"
      [contents]="recommendedCompanyContentsByLearner" [origin]="'recomendation'" [zIndex]="30">
    </app-owl-carousel>
  </section>

  <!--CALIFICADOS TENDENCIAS -->
  <section class="md:pt-0 pt-10" *ngIf="topRecomendations && topRecomendations.length > 0">
    <app-owl-carousel [title]="'words.trending' | translate"
      [subtitle]="'words.best-califications.subtitle' | translate" [contents]="topRecomendations"
      [origin]="'recomendation'" [zIndex]="20">
    </app-owl-carousel>
  </section>



  <!--== SECTION EXTRAS MODALES OCULTAS ==-->
  <!-- Fondo oscuro modal -->
  <div *ngIf="false" id="backdrop" class="bg-black-modal hidden" (click)="closeModal()"></div>
  <!-- Modal RECURSOS -->
  <div *ngIf="false" id="modal-resources"
    class=" fixed top-0 right-0 md:w-1/2 w-full h-full bg-white shadow-lg transform translate-x-full transition-transform ease-in-out duration-500 z-[9999] ">

    <!-- Titulo modal  -->
    <div class="bg-white py-4 px-7 shadow-sm border-b flex items-center justify-between ">
      <div class="flex items-center space-x-2">
        <i class="fas fa-book"></i>
        <h2 class="text-lg font-semibold text-gray-700 ">{{'words.resources' | translate}}</h2>
      </div>
      <button (click)="closeModal('resources')" class="text-xl">✖</button>
    </div>

    <!-- Contenido modal  -->
    <div class="p-6 grid grid-cols-1  h-screen md:h-[80vh]   gap-4">
      <div class="flex flex-col  gap-3 justify-flex-start">
        <span class="text-md text-gray-500"> {{'words.resources.message' | translate}} </span>
        <msc-widget-resource class="grow" [company]="company" [experience]="experience"></msc-widget-resource>
      </div>
    </div>
  </div>
  <!-- Modal  EXTRAS -->
  <div id="modal-extras"
    class=" fixed top-0 right-0 md:w-1/2 w-full h-full bg-white shadow-lg transform translate-x-full transition-transform ease-in-out duration-500 z-[9999] ">

    <!-- Titulo modal  -->
    <div class="bg-white py-4 px-7 shadow-sm border-b flex items-center justify-between ">
      <div class="flex items-center space-x-2">
        <i class="fas fa-book"></i>
        <h2 class="text-lg font-semibold text-gray-700">{{'words.events' | translate}}</h2>
      </div>
      <button (click)="closeModal('extras')" class="text-xl">✖</button>
    </div>

    <!-- Contenido modal  -->
    <div class="p-6 grid grid-cols-1    h-screen md:h-[80vh]   gap-4">
      <div class="flex flex-col  gap-3 justify-flex-start">
        <!-- Events empty-state  -->
        <msc-widget-next-event #nextEventWidget [company]="company" [autoLoad]="false"
          class="widget-contact-card"></msc-widget-next-event>

      </div>
    </div>

  </div>
  <!-- Modal NOTICIAS -->
  <div *ngIf="false" id="modal-news"
    class="overflow-y-scroll fixed top-0 right-0 md:w-1/2 w-full h-full bg-white shadow-lg transform translate-x-full transition-transform ease-in-out duration-500 z-[9999] ">

    <!-- Encabezado -->
    <div class="bg-white py-4 px-7 shadow-sm border-b flex items-center justify-between ">
      <div class="flex items-center space-x-2">
        <h2 class="text-lg font-semibold text-gray-700 ">{{'words.news' | translate}}</h2>
      </div>
      <button (click)="closeModal('news')" class="text-xl">✖</button>
    </div>

    <!-- Contenido del Modal -->

    <msc-timeline [context]="'company'" [contextId]="company.id" [isDashboard]="true" [displayCamp]="true"
      [small]="true" class="card-noticias hidden md:block lg:block 2xl:block xl:block p-6">
    </msc-timeline>


  </div>
  <!--CARDS EXTRAS-->
  <div *ngIf="false" class="extras my-8 relative z-0">
    <div class="relative mx-auto w-full max-w-[90%] lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%]">
      <div class="flex  items-center mb-3 pb-3 border-b border-gray-200">
        <h2 class="text-xl font-semibold">{{'words.extras' | translate}}</h2>
      </div>
      <h3 class="text-base text-gray-500 font-normal">{{'words.extra-more' | translate}}
      </h3>
    </div>

    <div class="overflow-hidden relative my-4">
      <div
        class=" container-extras flex w-full gap-4 mb-0 mt-4  md:my-4 flex-col lg:flex-row mx-auto max-w-[90%] lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%]"
        *ngIf="!(currentJob === 'learn' && company.id === 1843)">
        <!-- Contenedor de las dos primeras cards -->
        <div class="flex  lg:flex-row gap-4 w-full lg:w-1/2">
          <!-- primera Card resources -->
          <button class="card-button rounded-[14px] shadow-lg flex items-center justify-center cursor-pointer 
          w-full md:basis-1/2  h-40  lg:h-60 bg-cover bg-center overflow-hidden" style="background: 
            linear-gradient(180deg, rgba(255, 89, 0, 0.05) 0%, rgba(0, 0, 0, 0.6) 100%), 
            url('../../assets/images/img-recursos.jpg'); background-position: center;
            background-size: cover;" (click)="openModal('resources')">
            <div class="card-content min-w-[270px] flex items-center justify-center text-white font-semibold text-xl 
            transition-all duration-500 group-hover:scale-110 group-hover:text-orange-100">
              {{'words.resources' | translate}}
            </div>
          </button>

          <!-- Segunda Card events-->
          <button class="card-button rounded-[14px] shadow-lg flex items-center justify-center cursor-pointer 
          w-full md:basis-1/2 h-40  lg:h-60 bg-cover bg-center overflow-hidden" style="background: 
            linear-gradient(180deg, rgba(255, 89, 0, 0.05) 0%, rgba(0, 0, 0, 0.6) 100%), 
            url('../../assets/images/img-eventos.jpg'); background-position: center;
            background-size: cover;" (click)="openModal('extras')">
            <div class="card-content min-w-[270px] flex items-center justify-center text-white font-semibold text-xl 
            transition-all duration-500 group-hover:scale-110 group-hover:text-orange-100">
              {{'words.events' | translate}}
            </div>
          </button>
        </div>
        <!-- Noticias -->
        <button
          class="card-button-notice flex flex-col justify-center cursor-pointer p-6 shadow-lg rounded-[14px] text-white h-50 w-full md:basis-1/2 lg:basis-1/2 xl:basis-1/2"
          (click)="openModal('news')" style="background: linear-gradient(90.17deg, 
          var(--v2-color-primary-700) 0.12%, 
          var(--v2-color-primary-700) 12.12%,
          var(--v2-color-primary-600) 37.84%, 
          var(--v2-color-primary-500) 62.7%, 
          var(--v2-color-primary-500) 86.77%);
         ">

          <div class="flex w-full justify-between items-center mb-2">
            <div class="flex items-center space-x-2">
              <i
                class="fas fa-layer-group rounded-[6px] bg-white bg-opacity-10 py-2 px-3 shadow-lg text-gray-300 fa-sm text-sm "></i>
              <h2 class="text-xl font-semibold mx-3 text-white">{{'words.news' | translate}}</h2>
            </div>
          </div>

          <div class="news-wrapper w-full flex flex-col text-left">
            <div class="flex justify-between w-full ">
              <h3 class="text-base font-semibold  text-white">{{ shortName }}</h3>
              <span class="text-sm text-white hidden ">Hace 1 día</span>
            </div>
            <h2 class="text-base font-semibold text-white">{{'words.collaborators' | translate}} |
              {{company.experience.name}}</h2>
            <p class="text-sm w-4/5 mt-2 mb-4 font-normal description-2 text-white">{{'words.notice.message' |
              translate}}</p>
            <a class="text-xs self-end text-white hidden">{{'words.see-more' | translate}}</a>
          </div>

        </button>
      </div>

      <div id="extras-2"
        class="container-extras flex w-full gap-4 mb-0 mt-4 md:my-4 flex-col xl:flex-row mx-auto max-w-[90%] lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%]"
        *ngIf="currentJob == 'learn' && company.id == 1843">
        <!-- Contenedor de las primeras cards -->
        <div class="flex flex-col md:flex-row gap-4 w-full">
          <!-- primera Card resources -->
          <button class="card-button rounded-[14px] shadow-lg flex items-center justify-center cursor-pointer 
          w-full md:basis-1/2  h-40  lg:h-60 bg-cover bg-center overflow-hidden" style="background: 
            linear-gradient(180deg, rgba(255, 89, 0, 0.05) 0%, rgba(0, 0, 0, 0.6) 100%), 
            url('../../assets/images/img-recursos.jpg'); background-position: center;
            background-size: cover;" (click)="openModal('resources')">
            <div class="card-content min-w-[270px] flex items-center justify-center text-white font-semibold text-xl 
            transition-all duration-500 group-hover:scale-110 group-hover:text-orange-100">
              {{'words.resources' | translate}}
            </div>
          </button>

          <!-- Segunda Card events-->
          <button class="card-button rounded-[14px] shadow-lg flex items-center justify-center cursor-pointer 
          w-full md:basis-1/2 h-40  lg:h-60 bg-cover bg-center overflow-hidden" style="background: 
            linear-gradient(180deg, rgba(255, 89, 0, 0.05) 0%, rgba(0, 0, 0, 0.6) 100%), 
            url('../../assets/images/img-eventos.jpg'); background-position: center;
            background-size: cover;" (click)="openModal('extras')">
            <div class="card-content min-w-[270px] flex items-center justify-center text-white font-semibold text-xl 
            transition-all duration-500 group-hover:scale-110 group-hover:text-orange-100">
              {{'words.events' | translate}}
            </div>
          </button>

          <!-- Tercera Card siemens-->
          <button class="card-button rounded-[14px] shadow-lg flex items-center justify-center cursor-pointer 
          w-full md:basis-1/2 h-40  lg:h-60 bg-cover bg-center overflow-hidden" style="background: 
            linear-gradient(180deg, rgba(255, 89, 0, 0.05) 0%, rgba(0, 0, 0, 0.6) 100%), 
            url('../../assets/images/img-siemens.jpg'); background-position: center;
            background-size: cover;" (click)="openCoronaSiemens()">
            <div class="card-content min-w-[270px] flex items-center justify-center text-white font-semibold text-xl 
            transition-all duration-500 group-hover:scale-110 group-hover:text-orange-100">
              {{'sidebar.corona.siemens' | translate}}
            </div>
          </button>
        </div>
        <!-- Noticias -->
        <button
          class="card-button-notice flex flex-col justify-center cursor-pointer p-6 shadow-lg rounded-[14px] text-white h-50 w-full md:w-full lg:basis-1/2 xl:basis-1/2"
          (click)="openModal('news')" style="background: linear-gradient(90.17deg, 
          var(--v2-color-primary-700) 0.12%, 
          var(--v2-color-primary-700) 12.12%,
          var(--v2-color-primary-600) 37.84%, 
          var(--v2-color-primary-500) 62.7%, 
          var(--v2-color-primary-500) 86.77%);
         ">

          <div class="flex w-full justify-between items-center mb-2">
            <div class="flex items-center space-x-2">
              <i
                class="fas fa-layer-group rounded-[6px] bg-white bg-opacity-10 py-2 px-3 shadow-lg text-gray-300 fa-sm text-sm "></i>
              <h2 class="text-xl font-semibold mx-3 text-white">{{'words.news' | translate}}</h2>
            </div>
          </div>

          <div class="news-wrapper w-full flex flex-col text-left">
            <div class="flex justify-between w-full ">
              <h3 class="text-base font-semibold  text-white">{{ shortName }}</h3>
              <span class="text-sm text-white hidden ">Hace 1 día</span>
            </div>
            <h2 class="text-base font-semibold text-white">{{'words.collaborators' | translate}} |
              {{company.experience.name}}</h2>
            <p class="text-sm w-4/5 mt-2 mb-4 font-normal description-2 text-white">{{'words.notice.message' |
              translate}}</p>
            <a class="text-xs self-end text-white hidden">{{'words.see-more' | translate}}</a>
          </div>

        </button>
      </div>
    </div>

  </div>

  <!-- FOOTER  -->
  <app-footer></app-footer>

<!--
  [SCROLL-TO-TOP] Botón flotante para volver al tope de la página.
  - Aparece tras 300px de scroll (controlado por showScrollTop en el .ts).
  - La clase .no-chat se añade dinámicamente cuando el floating-chat IA
    no está habilitado (companyAiAssistant !== true), bajando el botón
    a bottom: 24px para ocupar el espacio libre de la esquina inferior derecha.
-->
<button
  *ngIf="showScrollTop"
  (click)="scrollToTop()"
  [class.no-chat]="!isChatEnabled"
  class="scroll-to-top-btn"
  aria-label="Volver arriba"
  title="Volver arriba">
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
    <polyline points="18 15 12 9 6 15"></polyline>
  </svg>
</button>